<div class="billing-subscription">
  <ng-container *ngIf="subscriptionList.length > 0; else noSubscriptionTemplate">
    <ng-container *ngFor="let item of subscriptionList">
      <div class="billing-subscription__item" [class.deactive]="item.active == 0 ">
        <div class="billing-subscription__item__panel">
          <div class="billing-subscription__item__panel--row">
            <span class="label" i18n="@@billing.subscription">Subscription</span>
            <!-- الاشتراك -->
            <span class="value secondary" i18n="@@billing.basic_plan">{{ item.subscription_type }}</span>
            <!-- الباقة الأساسية -->
          </div>

          <div class="billing-subscription__item__panel--row" *ngIf="!item.is_manual">
            <span class="label" i18n="@@billing.id">ID</span> <!-- الهوية الشخصية -->
            <span class="value">{{ item.subscription_id }}</span>
          </div>
        </div>

        <div class="billing-subscription__item__panel">
          <div class="billing-subscription__item__panel--row">
            <span class="label" i18n="@@billing.payment_for">Payment for </span><!-- الدفع من -->
            <span class="value">{{ item.start_date }}</span>
          </div>

          <div class="billing-subscription__item__panel--row">
            <span class="label" i18n="@@billing.expires_on">Expires on</span><!-- ينتهي الاشتراك في -->
            <span class="value highlight">{{ item.expired_at }}</span>
          </div>

          <div class="billing-subscription__item__panel--row">
            <span class="label" i18n="@@billing.status">Status</span><!-- الحالة -->
            <span class="value " [ngClass]="{'secondary': item.active == 1 , 'highlight ': item.active == 0 }">{{ item.active == 1 ? 'Active': 'Inactive' }}</span><!-- نشط -->
          </div>
        </div>

        <div class="billing-subscription__item__panel panel-large">
          <!--   -->
          <div class="billing-subscription__item__panel--row" *ngIf="item.card_digit != ''">
            <span class="label">
              <svg width="20" height="20" viewBox="0 0 20 20">
                <g class="svg-stroke" fill="none" fill-rule="evenodd" stroke-width="1.5">
                  <path d="M7.75 11.5v.75c0 .745.688 1.5 1.517 1.5h1.483c.828 0 1.5-.755 1.5-1.5v-.227c0-.582-.405-1.097-1.017-1.28l-2.453-.736c-.612-.183-1.03-.698-1.03-1.28V8.5c0-.745.672-1.5 1.5-1.5h1.5c.828 0 1.5.755 1.5 1.5v.75M10 7V4.75M10 13.75V16" />
                  <path d="M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" />
                </g>
              </svg>
              <ng-container i18n="@@billing.payment_for">Payment for</ng-container><!-- الدفع من -->
            </span>
            <span *ngIf="item.card_digit != ''">
              <i class="card-icon {{ item.card_type | lowercase }}"></i>
              <strong>{{ item.card_digit }}</strong>
            </span>
          </div>

          <div class="billing-subscription__item__panel--row" [ngClass]="{'billing-subscription__item__panel--row--controls': item.active == 1 && item.auto_renew == 1 }">
            <ng-container *ngIf="item.cancel_date != null ">
              <span class="label" i18n="@@billing.cancelled_on">Cancelled On</span>
              <span class="value highlight">{{ item.cancel_date }}</span>
            </ng-container>

            <div class="switch-wrapper" *ngIf="(item.payment_by != 'in-app') && (item.active == 1 && !item.is_manual) && (item.cancelled_by == 'user' || item.cancelled_by == null)">
              <div class="switch">
                <input type="checkbox" *ngIf="item.cancel_date == null" [checked]="!item.auto_renew" (change)="updateAutoRenew(item.uuid, $event,item)">
                <input type="checkbox" *ngIf="item.cancel_date != null" [checked]="!item.auto_renew" (change)="cancelAutoRenewOff(item.uuid, $event,item)">
                <span class="slider round"></span>
              </div>
              <label for="auto-renew" *ngIf="item.cancel_date == null"><strong i18n="@@billing.auto_renew">Auto Renew</strong></label>
              <label for="auto-renew" *ngIf="item.cancel_date != null"><strong i18n="@@billing.auto_renew">Resume Subscription</strong></label> 
            </div>
          </div>
        </div>

      </div>
    </ng-container>
  </ng-container>

  <ng-template #noSubscriptionTemplate>
    <div class="billing-subscription__item">
      <div class="billing-subscription__item__panel panel-large no-subscription">
        <span i18n="@@common.no_record_found">No subscription Found</span>
      </div>
    </div>
  </ng-template>

</div>